import { post, get } from "../helpers/apiHelper";
import { Api } from "../constants";
import {
  ReportRequest,
  ReportResponse,
  ReportedItemsFetchResponse,
  ReportData,
  ReportType,
  ListReviewsRequest,
  ListReviewsResponse,
} from "../types";
import { ERROR_MESSAGES, REPORT_TYPE } from "../utils/constants";

const API_ENDPOINTS = {
  CREATE_REVIEW: "create",
  LIST_REVIEWS: "list",
}

//Report an item or user
export const reportItemOrUser = async (
  data: ReportData,
  reportType: ReportType,
  reportedBy: string
): Promise<ReportResponse> => {
  const url = `${Api.reviews}/${API_ENDPOINTS.CREATE_REVIEW}`;
  const formData = new FormData();
  const reportedUserId = data.userId || data.itemOwner;
  if (data.images && data.images.length > 0) {
    data.images.forEach((image) => {
      if (image.originFileObj) {
        formData.append("images", image.originFileObj, image.name);
      }
    });
  }

  const reportRequest: ReportRequest = {
    reviewType: reportType,
    reviewCategory: data.category,
    description: data.description,
    reportedBy,
  };
  if (data.itemId) {
    reportRequest.itemId = data.itemId;
  }
  if (reportedUserId) {
    reportRequest.userId = reportedUserId;
  }

  if (reportType === REPORT_TYPE.ITEM && !data.itemId) {
    throw new Error(ERROR_MESSAGES.ITEM_ID_REQUIRED_FOR_REPORTING_ITEM);
  } else if (reportType === REPORT_TYPE.USER && !reportedUserId) {
    throw new Error(ERROR_MESSAGES.USER_ID_REQUIRED_FOR_REPORTING_USER);
  }

  formData.append(
    "reviewRequest",
    new Blob([JSON.stringify(reportRequest)], { type: "application/json" })
  );

  return await post<ReportResponse>(url, formData);
};

//Fetch Reported Items for admin
export const getReportedItemsForAdmin = async (): Promise<ReportedItemsFetchResponse> => {
  const url = `${Api.adminRestricted}/reported-items?reviewType=ITEM`;
  return await get(url);
}

//Fetch Review Details by reviewId
export const getReviewDetails = async (reviewId: string): Promise<ReportResponse> => {
  const url = `${Api.reviews}/${reviewId}`;
  return await get<ReportResponse>(url);
}

//List Reviews
export const listReviews = async (request: ListReviewsRequest): Promise<ListReviewsResponse> => {
  const url = `${Api.reviews}/${API_ENDPOINTS.LIST_REVIEWS}`;
  return await post<ListReviewsResponse>(url, request);
}
